export const UNIVERSITY_LIST_REQ = "UNIVERSITY_LIST_REQ";
export const UNIVERSITY_LIST_SUCCESS = "UNIVERSITY_LIST_SUCCESS";
export const UNIVERSITY_LIST_FAILED = "UNIVERSITY_LIST_FAILED";
export const UNIVERSITY_LIST_RESET = "UNIVERSITY_LIST_RESET";

export const UNIVERSITY_SINGLE_DATA_REQ = "UNIVERSITY_SINGLE_DATA_REQ";
export const UNIVERSITY_SINGLE_DATA_SUCCESS = "UNIVERSITY_SINGLE_DATA_SUCCESS";
export const UNIVERSITY_SINGLE_DATA_FAILED = "UNIVERSITY_SINGLE_DATA_FAILED";
export const UNIVERSITY_SINGLE_DATA_RESET = "UNIVERSITY_SINGLE_DATA_RESET";

export const CREATE_UNIVERSITY_REQ = "CREATE_UNIVERSITY_REQ";
export const CREATE_UNIVERSITY_SUCCESS = "CREATE_UNIVERSITY_SUCCESS";
export const CREATE_UNIVERSITY_FAILED = "CREATE_UNIVERSITY_FAILED";
export const CREATE_UNIVERSITY_RESET = "CREATE_UNIVERSITY_RESET";

export const UPDATE_UNIVERSITY_REQ = "UPDATE_UNIVERSITY_REQ";
export const UPDATE_UNIVERSITY_SUCCESS = "UPDATE_UNIVERSITY_SUCCESS";
export const UPDATE_UNIVERSITY_FAILED = "UPDATE_UNIVERSITY_FAILED";
export const UPDATE_UNIVERSITY_RESET = "UPDATE_UNIVERSITY_RESET";

export const DELETE_UNIVERSITY_REQ = "DELETE_UNIVERSITY_REQ";
export const DELETE_UNIVERSITY_SUCCESS = "DELETE_UNIVERSITY_SUCCESS";
export const DELETE_UNIVERSITY_FAILED = "DELETE_UNIVERSITY_FAILED";
export const DELETE_UNIVERSITY_RESET = "DELETE_UNIVERSITY_RESET";
